import { getEl } from './dom.js';

const USERNAME_REGEX = /^[A-Za-z0-9-_]+$/;
const USERNAME_MAX = 15;
const USERNAME_MIN = 2;
const VALID_PERIODS = ['0', '1', '3', '6', '12'];
const VALID_DATA = ['artists', 'tracks']

const USEROPTS = ['username', 'data', 'period', 'palette', 'showUsername', 'minimizeVA', 'platform', 'useInternationalFont'];

export function getOptionsFromForm() {
  let userOpts = {};

  let username = getEl('username');
  if (username) {
    userOpts.username = username.value;
  }

  let period = getEl('period');
  if (period) {
    userOpts.period = period.value;
  }

  let data = document.querySelector('input[name="data"]:checked');
  if (data) {
    userOpts.data = data.value;
  }

  let palette = getEl('palette');
  if (palette) {
    userOpts.palette = palette.value;
  }

  let showUsername = getEl('showUsername');
  if (showUsername) {
    userOpts.showUsername = (showUsername.checked) ? true : false;
  }

  let useInternationalFont = getEl('useInternationalFont');
  if (useInternationalFont) {
    userOpts.useInternationalFont = (useInternationalFont.checked) ? true : false;
  }

  let minimizeVA = getEl('minimizeVA');
  if (minimizeVA) {
    userOpts.minimizeVA = (minimizeVA.checked) ? true : false;
  }

  let platform = getEl('platform');
  if (platform) {
    userOpts.platform = platform.value;
  }

  return userOpts;
}

export function putOptionsIntoForm(options) {
  let username = getEl('username');
  if (username && typeof options.username !== 'undefined') {
    username.value = options.username;
  }

  let period = getEl('period');
  if (period && typeof options.period !== 'undefined') {
    period.value = options.period;
  }

  let data = document.querySelector('input[name="data"]');
  if (data && typeof options.data !== 'undefined') {
    data.setAttribute('checked', options.data);
  }

  let palette = getEl('palette');
  if (palette && typeof options.palette !== 'undefined') {
    palette.value = options.palette;
  }

  let showUsername = getEl('showUsername');
  if (showUsername && typeof options.showUsername !== 'undefined') {
    showUsername.checked = options.showUsername;
  }

  let useInternationalFont = getEl('useInternationalFont');
  if (useInternationalFont && typeof options.useInternationalFont !== 'undefined') {
    useInternationalFont.checked = options.useInternationalFont;
  }

  let minimizeVA = getEl('minimizeVA');
  if (minimizeVA && typeof options.minimizeVA !== 'undefined') {
    minimizeVA.checked = options.minimizeVA;
  }

  let platform = getEl('platform');
  if (platform && typeof options.platform !== 'undefined') {
    platform.value = options.platform;
  }
}

export function getOptionsFromCookie() {
  let cookieValue = document.cookie.match('(^|;)\\s*options\\s*=\\s*([^;]+)')?.pop() || '';
  if (cookieValue) {
    if (cookieValue.startsWith('%')) {
      cookieValue = decodeURIComponent(cookieValue);
    }
    return scrubOptions(JSON.parse(cookieValue));
  }
  return null;
}

export function saveOptionsToCookie(options) {
  let existingOptions = getOptionsFromCookie();
  let newOptions = options;

  if (existingOptions) {
    newOptions = Object.assign(existingOptions, newOptions);
  }

  document.cookie = "options=" + encodeURIComponent(JSON.stringify(scrubOptions(newOptions))) + "; max-age: 31536000; path=/";
}

export function deleteCookie() {
  document.cookie = "options=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
}

function scrubOptions(options) {
  Object.entries(options).forEach(([field]) => {
    if (!USEROPTS.includes(field)) {
      delete (options[field]);
    }
  });

  return options;
}

export function validateUserOpts(options) {

  const errors = {};

  if (options.username.length == 0) {
    errors.username = '';
  } else

    // Validate Username
    if (options.username.length > USERNAME_MAX || options.username.length < USERNAME_MIN || !USERNAME_REGEX.test(options.username)) {
      errors.username = 'Invalid username.'
    }

  if (options.period && !VALID_PERIODS.includes(options.period)) {
    errors.period = 'No valid timeframe selected';
  }

  if (options.data && !VALID_DATA.includes(options.data)) {
    errors.data = 'No valid data selected.';
  }

  return errors;
}